import { render } from "./RefreshHome.vue?vue&type=template&id=494e3870"
import script from "./RefreshHome.vue?vue&type=script&lang=js"
export * from "./RefreshHome.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_ada65e43/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__